import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminUserItem from '../../components/AdminUserItem';
import SideBarAdmin from '../../components/SideBarAdmin';

import { useAxios } from '../../utils/hook/useAxios';
function AdminUserItemPage() {
  const axios = useAxios();
  const [user, setUser] = useState(null);
  const { userId } = useParams();
  const [permisStatus, setPermisStatus] = useState('');
  const [identityStatus, setIdentityStatus] = useState('');

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(`/users/searchbyid/${userId}`);
        if (response.data) {
          setUser(response.data);
          setPermisStatus(
            !response.data?.PermisConduireDoc
              ? 'missing'
              : response.data?.PermisConduire == '1'
                ? 'approved'
                : 'pending'
          );
          setIdentityStatus(
            !response.data?.PieceIdentityDoc
              ? 'missing'
              : response.data?.PieceIdentite == '1'
                ? 'approved'
                : 'pending'
          );
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <section className="bg-body-tertiary">
      <div className="container">
        <div className="row">
          <h1 className="mb-3">
            {user?.firstName} {user?.lastName}{' '}
            <span className="px-2 h4">
              {/* Statut compte */}
              {user?.verified == '0' && (
                <span className="text-warning me-2">
                  <i className="bi bi-clock-history"></i> En attente
                </span>
              )}

              {user?.verified == '1' && (
                <span className="text-success me-2">
                  <i className="bi bi-check2-circle"></i> Approuvé
                </span>
              )}

              {/* Permis */}
              {permisStatus === 'missing' && (
                <span className="text-danger me-2">
                  <i className="bi bi-exclamation-triangle"></i> Permis manquant
                </span>
              )}

              {permisStatus === 'pending' && (
                <span className="text-warning me-2">
                  <i className="bi bi-hourglass-split"></i> Permis en validation
                </span>
              )}

              {permisStatus === 'approved' && (
                <span className="text-success me-2">
                  <i className="bi bi-check-circle"></i> Permis validé
                </span>
              )}

              {/* Identité */}
              {identityStatus === 'missing' && (
                <span className="text-danger">
                  <i className="bi bi-exclamation-triangle"></i> Identité manquante
                </span>
              )}

              {identityStatus === 'pending' && (
                <span className="text-warning">
                  <i className="bi bi-hourglass-split"></i> Identité en validation
                </span>
              )}

              {identityStatus === 'approved' && (
                <span className="text-success">
                  <i className="bi bi-check-circle"></i> Identité validée
                </span>
              )}
            </span>
          </h1>

          <div className="col-md-3 mb-3 d-none d-sm-block">
            <SideBarAdmin></SideBarAdmin>
          </div>
          <div className="col-md-8 mb-3">
            <AdminUserItem data={user}></AdminUserItem>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminUserItemPage;
